import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import './i18n/config'; // Initialize i18n
import App from './App.tsx';
import theme from './theme.tsx';
import { initializeThirdPartyServices } from './third-party/ThirdParty';
import './services/SessionService'; // Initialize session service

// Initialize third-party services before React
initializeThirdPartyServices();
// Session management is now handled automatically by SessionService

createRoot(document.getElementById('root')!).render(
  <ThemeProvider theme={theme}>
    <StrictMode>
      <App />
    </StrictMode>
  </ThemeProvider>
);